// filepath: /home/toofoocustomer/tf-node/tf_customer_web/components/customer/LoginExperience.tsx

"use client";

import { LoginForm } from "@/components/customer/LoginForm";
import { ServiceAuthFrame } from "@/components/customer/ServiceAuthFrame";

type Props = {
  resume?: string;
};

export function LoginExperience({ resume }: Props) {
  return (
    <ServiceAuthFrame
      resume={resume}
      eyebrow="WELCOME BACK"
      title="로그인"
      defaultDescription="TOOFOO 공통 계정으로 로그인합니다."
      serviceDescriptionMode="login"
      dataE2e="customer-login"
    >
      <LoginForm resume={resume} />
    </ServiceAuthFrame>
  );
}
